import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(localStorage.getItem('barberflow_cookie_notice') !== 'accepted');
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-3xl rounded-xl border border-dark-600 bg-dark-800/95 p-4 shadow-2xl backdrop-blur">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="text-sm text-gray-300 flex-1">
          Usamos sessão local para login e funcionamento do sistema. Veja a{' '}
          <Link to="/privacy" className="text-primary-300 hover:text-primary-200">
            Política de Privacidade
          </Link>.
        </p>
        <button
          type="button"
          className="btn-primary px-5 py-2 text-sm"
          onClick={() => {
            localStorage.setItem('barberflow_cookie_notice', 'accepted');
            setVisible(false);
          }}
        >
          Entendi
        </button>
      </div>
    </div>
  );
}
